<template>
  <div class="flex flex-col items-center">
    <transition-group
      class="flex justify-center align-center overflow-hidden"
      tag="div"
      :style="{ width: `${height + 2 * margin}em`, minHeight: `${height}em` }"
    >
      <div
        v-for="slide in current"
        :key="slide.id"
        class="slide flex justify-center align-center overflow-hidden"
        :style="{
          flex: `0 0 ${height - 2 * margin}em`,
          height: `${height}em`,
          margin: `${margin}em`,
        }"
      >
        <div class="block w-auto">
          <img :src="slide.imageSrc" />
          <div
            class="bg-black opacity-50 relative z-50 h-48 w-full"
            :style="{ top: `${slide.top}px`, left: `${slide.left}px` }"
          ></div>
          <div class="relative" :style="{ top: `${slide.top - 180}px`, left: `${slide.left + 15}px` }">
            <h2 class="text-base text-xl opacity-100 relative text-white z-50">
              {{ slide.title }}
            </h2>
            <button class="text-base text-xl opacity-100 relative bg-white text-wine z-50 p-2">
              {{ slide.callToAction }}
            </button>
          </div>
        </div>
      </div>
    </transition-group>
    <div class="flex align-center justify-center my-4">
      <button class="text-wine mr-8" @click="previous">
        <font-awesome-icon icon="chevron-circle-left" size="3x" />
      </button>
      <button class="text-wine ml-8" @click="next">
        <font-awesome-icon icon="chevron-circle-right" size="3x" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slides: {
      type: Array,
      required: true,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 22,
    },
    margin: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      current: [],
      timer: undefined,
    }
  },
  created() {
    this.current = [].concat(this.slides)
    if (this.autoplay) this.reset()
  },
  methods: {
    reset() {
      const _this = this
      this.timer = setInterval(() => _this.next(), 6000)
    },
    next() {
      if (this.current.length) {
        clearInterval(this.timer)
        const first = this.current.shift()
        this.current = this.current.concat(first)
        if (this.autoplay) this.reset()
      }
    },
    previous() {
      if (this.current.length) {
        clearInterval(this.timer)
        const last = this.current.pop()
        this.current = [last].concat(this.current)
        if (this.autoplay) this.reset()
      }
    },
  },
}
</script>

<style>
.slide {
  transition: transform 0.3s ease-in-out;
}
.slide:first-of-type {
  opacity: 0;
}
.slide:last-of-type {
  opacity: 0;
}
</style>
